/**
 * Guard feature flag zoo.
 * Verifica appStore.hasFeatureFlag('zoo').
 * Bypass in sviluppo: localStorage.setItem('zoo_dev', 'true')
 */
async function zooGuard() {
  //Abilitata per tutti - in futuro si può usare un feature flag
  // if (localStorage.getItem('zoo_dev') === 'true') return true

  // const appStore = useAppStore()
  // if (!appStore.hasFeatureFlag('zoo')) {
  //   return { name: 'FarmCenterDetailView', params: { id: to.params.farmCenterId } }
  // }
  return true
}

export default [
  {
    path: '/poderi/:farmCenterId/zoo',
    name: 'ZooHome',
    component: () => import('./views/ZooHome.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },

  // ==================== GREGGE (HERD) ====================

  {
    path: '/poderi/:farmCenterId/zoo/nuovo-gregge',
    name: 'HerdCreate',
    component: () => import('./views/HerdUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/modifica-gregge',
    name: 'HerdEdit',
    component: () => import('./views/HerdUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd',
    name: 'HerdHome',
    component: () => import('./views/HerdHome.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },

  // ==================== ANIMALI ====================

  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/animali/importa-bdn',
    name: 'AddAnimals',
    component: () => import('./views/AddAnimalsView.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/animali/nuovo',
    name: 'AnimalCreate',
    component: () => import('./views/AnimalUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/animali/:id_animal',
    name: 'AnimalDetail',
    component: () => import('./views/AnimalDetail.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/animali/:id_animal/modifica',
    name: 'AnimalEdit',
    component: () => import('./views/AnimalUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/animali/:id_animal/rimuovi/:type_out',
    name: 'AnimalRemove',
    component: () => import('./views/AnimalRemove.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },

  // ==================== EVENTI ANIMALE ====================

  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/animali/:id_animal/evento/nuovo',
    name: 'EventCreate',
    component: () => import('./views/EventUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/animali/:id_animal/evento/:id_event/modifica',
    name: 'EventEdit',
    component: () => import('./views/EventUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },

  // ==================== GRUPPI ====================

  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/gruppi',
    name: 'GroupList',
    component: () => import('./views/GroupList.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/gruppi/nuovo',
    name: 'GroupCreate',
    component: () => import('./views/GroupUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/gruppi/:id_group',
    name: 'GroupDetail',
    component: () => import('./views/GroupDetail.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/gruppi/:id_group/modifica',
    name: 'GroupEdit',
    component: () => import('./views/GroupUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/gruppi/:id_group/aggiungi-animali',
    name: 'GroupAddAnimals',
    component: () => import('./views/GroupAddAnimals.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },

  // ==================== EVENTI GRUPPO ====================

  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/gruppi/:id_group/evento/nuovo',
    name: 'GroupEventCreate',
    component: () => import('./views/GroupEventUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/gruppi/:id_group/evento/:id_event/modifica',
    name: 'GroupEventEdit',
    component: () => import('./views/GroupEventUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },

  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/gruppi/dinamica',
    name: 'GroupDynamics',
    component: () => import('./views/GroupDynamicsView.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },

  // ==================== DASHBOARD ====================

  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/dashboard/razioni',
    name: 'RationsDashboard',
    component: () => import('./views/RationsDashboard.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/dashboard/fertilita',
    name: 'FertilityDashboard',
    component: () => import('./views/FertilityDashboard.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },

  // ==================== BLUETOOTH ====================

  {
    path: '/poderi/:farmCenterId/zoo/bluetooth',
    name: 'BluetoothReader',
    component: () => import('./views/BluetoothPage.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/bluetooth/evento/:id_animal',
    name: 'EventCreateFromBluetooth',
    component: () => import('./views/EventUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true, fromBluetooth: true }
  },
  {
    path: '/poderi/:farmCenterId/zoo/:id_herd/animali/nuovo/:code_bdn',
    name: 'AnimalCreateWithBDN',
    component: () => import('./views/AnimalUpsert.vue'),
    beforeEnter: zooGuard,
    meta: { requiresAuth: true }
  },
]
